import React from 'react';
import IconButton from 'material-ui/IconButton';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';

import {
    Grid,
    Icon,
    GridColumns,
    Column,
} from '../../components';
import {
    eventoService,
    subeventoService,
    Utils,
} from '../../services';
import PrincipalMaster from '../master/Principal';
import Areas from '../area/Areas';
import Assinaturas from '../assinatura/Assinaturas';
import Categorias from '../categoria/Categorias';
import Criterios from '../criterio/Criterios';
import TiposApresentacao from '../tipoapresentacao/TiposApresentacao';


const dsOpcoes = [
    {
        nome: 'Áreas',
        opcao: 'areas',
    },
    // {
    //     nome: 'Assinaturas',
    //     opcao: 'assinaturas',
    // },
    {
        nome: 'Categorias',
        opcao: 'categorias',
    },
    {
        nome: 'Coordenadores de subevento',
        opcao: 'coordenadoressubevento',
    },
    // {
    //     nome: 'Critérios',
    //     opcao: 'criterios',
    // },
    {
        nome: 'Tipos de apresentação',
        opcao: 'tiposapresentacao',
    },
];

class Eventos extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            dsSubEventos: [],
            eventoSelecionado: 0,
            subeventoSelecionado: 0,
            dsEventos: [],
            opcaoSelecionada: '',
        };
        Utils.showLoading(true);
    }

    async componentWillMount() {
        await this.getEventos();
        const { evento, subevento, opcao } = this.props.match.params;
        if (evento) {
            await this.buscarSubeventos(evento);
            if (subevento) {
                this.setState({ subeventoSelecionado: subevento });
                const opcaoSelecionada = this.getOpcaoSelecionadaNaUrl(opcao);
                if (opcaoSelecionada) {
                    this.setState({ opcaoSelecionada });
                }
            }
        }
        Utils.showLoading(false);
    }

    async getEventos() {
        const dsEventos = await eventoService.getAll();
        this.setState({ dsEventos });
    }

    getOpcaoSelecionadaNaUrl(opcao) {
        const opcoes = dsOpcoes.filter(x => x.opcao === opcao);
        if (opcoes.length === 0) {
            return null;
        }
        return opcoes[0];
    }

    async deleteEvento(codigo) {
        if (window.confirm('Deseja excluir o evento?')) {
            try {
                const _csrf = (await eventoService.eventoForm()).token;
                const respose = await eventoService.delete({ codigo, _csrf });
                Utils.showToast(respose.message);
                this.getEventos();
                this.eventosGridRef.resetPageIndex();
            } catch (e) {
                Utils.showToast(e.message);
            }
        }
    }

    async deleteSubevento(codigo) {
        if (window.confirm('Deseja excluir o subevento?')) {
            try {
                const _csrf = (await subeventoService.subeventoForm()).token;
                const respose = await subeventoService.delete({ codigo, _csrf });
                Utils.showToast(respose.message);
                this.subEventosGridRef.update();
            } catch (e) {
                Utils.showToast(e.message);
            }
        }
    }

    async newEvento() {
        this.props.history.push('/eventos/add');
    }

    async newSubevento(subevento) {
        this.props.history.push(`/subeventos/add/${subevento}`);
    }

    async buscarSubeventos(evento) {
        this.setState({ eventoSelecionado: evento });
        const subeventos = await subeventoService.getSubeventosDoEvento(evento);
        this.setState({ dsSubEventos: subeventos });
    }

    async buscarSubeventosPushRouter(evento) {
        await this.buscarSubeventos(evento);
        this.props.history.push(`/eventos/${evento}`);
    }

    getUrlSubevento(evento, subevento) {
        this.setState({ subeventoSelecionado: subevento });
        this.props.history.push(`/eventos/${evento}/${subevento}`);
    }

    getUrlOpcoes(evento, subevento, opcao) {
        this.setState({ opcaoSelecionada: opcao });
        this.props.history.push(`/eventos/${evento}/${subevento}/${opcao.opcao}`);
    }

    getGridOpcao() {
        const { subeventoSelecionado, opcaoSelecionada } = this.state;
        switch (opcaoSelecionada.opcao) {
            case 'areas':
                return <Areas subevento={subeventoSelecionado} />;

            case 'assinaturas':
                return <Assinaturas subevento={subeventoSelecionado} />;

            case 'categorias':
                return <Categorias subevento={subeventoSelecionado} />;

            case 'criterios':
                return <Criterios subevento={subeventoSelecionado} />;

            case 'tiposApresentacao':
                return <TiposApresentacao subevento={subeventoSelecionado} />;

            default:
                return <h4>Selecione alguma das opções.</h4>;
        }
    }

    render() {
        const {
            eventoSelecionado,
            subeventoSelecionado,
            opcaoSelecionada,
            dsSubEventos,
            dsEventos,
        } = this.state;

        return (
            <PrincipalMaster title="Eventos" {...this.props}>
                <GridColumns>
                    <Column width={600}>
                        <div className="padding-content">
                            <h3>Eventos</h3>
                            <Grid
                                ref={ref => this.eventosGridRef = ref}
                                columnSortDefault={1}
                                textTableEmpty="Nenhum evento encontrado."
                                dataSource={dsEventos}
                                columns={[
                                    {
                                        text: 'Ano', name: 'ANO', allowSort: true, allowSearch: true,
                                    },
                                    {
                                        text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE',
                                    },
                                    {
                                        name: item => (
                                            <div style={{ textAlign: 'center' }}>
                                                <IconButton onClick={() => this.props.history.push(`/eventos/add/${item.CODIGO}`)}>
                                                    <Icon name="edit" />
                                                </IconButton>
                                                <IconButton onClick={() => this.deleteEvento(item.CODIGO)}>
                                                    <Icon name="delete" />
                                                </IconButton>
                                                <IconButton onClick={() => this.buscarSubeventosPushRouter(item.CODIGO)}>
                                                    <Icon name="forward" />
                                                </IconButton>
                                            </div>
                                        ),
                                    },
                                ]}
                            />
                        </div>
                        <div className="fab-buttons-eventos">
                            <FloatingActionButton mini onClick={() => this.newEvento()}>
                                <ContentAdd />
                            </FloatingActionButton>
                        </div>
                    </Column>
                    {
                        eventoSelecionado &&
                        <Column width={480}>
                            <div className="padding-content">
                                <h3>Subeventos</h3>
                                <Grid
                                    ref={ref => this.subEventosGridRef = ref}
                                    columnSortDefault={0}
                                    showSearch={false}
                                    textTableEmpty="Nenhum subevento encontrado."
                                    dataSource={dsSubEventos}
                                    columns={[
                                        {
                                            text: 'Nome', name: 'NOME', allowSort: true, allowSearch: true, searchOperator: 'LIKE'
                                        },
                                        {
                                            name: item => (
                                                <div style={{ textAlign: 'center' }}>
                                                    <IconButton onClick={() => this.props.history.push(`/subeventos/add/${eventoSelecionado}/${item.CODIGO}`)}>
                                                        <Icon name="edit" />
                                                    </IconButton>
                                                    <IconButton onClick={() => this.deleteSubevento(item.CODIGO)}>
                                                        <Icon name="delete" />
                                                    </IconButton>
                                                    <IconButton onClick={() => this.getUrlSubevento(eventoSelecionado, item.CODIGO)}>
                                                        <Icon name="forward" />
                                                    </IconButton>
                                                </div>
                                            ),
                                        },
                                    ]}
                                />
                            </div>
                            <div className="fab-buttons-eventos">
                                <FloatingActionButton mini onClick={() => this.newSubevento(eventoSelecionado, subeventoSelecionado)}>
                                    <ContentAdd />
                                </FloatingActionButton>
                            </div>
                        </Column>
                    }
                    {
                        (subeventoSelecionado && eventoSelecionado) &&
                        <Column width={280}>
                            <Menu>
                                {
                                    dsOpcoes.map((item, index) => (
                                        <MenuItem
                                            style={opcaoSelecionada.opcao === item.opcao ? styles.selectedOpcaoMenuItem : {}}
                                            primaryText={item.nome}
                                            key={index}
                                            onClick={() => this.getUrlOpcoes(eventoSelecionado, subeventoSelecionado, item)} />
                                    ))
                                }
                            </Menu>
                        </Column>
                    }
                    {
                        (subeventoSelecionado && eventoSelecionado && !!opcaoSelecionada) &&
                        <Column width={480}>
                            <div className="padding-content">
                                <h3>{opcaoSelecionada.nome}</h3>
                                {
                                    this.getGridOpcao()
                                }
                            </div>
                        </Column>
                    }
                </GridColumns>
            </PrincipalMaster>
        );
    }
}

const styles = {
    selectedOpcaoMenuItem: {
        backgroundColor: 'rgba(0, 0, 0, 0.0980392)',
    },
};

export default Eventos;
